<template>
  <div v-if="state.isModalOpen" class="modal is-active">
    <div class="modal-background" @click="closeModal" />
    <div
      class="modal-content ai-describe-animal is-flex is-justify-content-center is-align-items-center"
    >
      <div v-if="state.isLoading" :class="{ loader: state.isLoading }" />
      <div
        v-else
        class="content-container is-flex is-justify-content-space-around is-flex-direction-column is-align-items-center"
      >
        <div class="modal-header mb-4">
          <h1 class="has-text-weight-semibold">
            Esse texto foi gerado por IA. Confira e, se necessário, edite antes
            de publicar.
          </h1>
        </div>
        <div
          v-if="props.animals.length > 1"
          class="is-flex is-justify-content-space-evenly mt-3"
        >
          <span
            v-for="animal in props.animals"
            :key="animal.id"
            class="ml-5"
            :class="{
              'has-text-weight-bold has-text-primary':
                state.descriptionsToPublish[state.currentAnimalIndex]
                  .animal_id === animal.id,
            }"
          >
            {{ animal.register }}
          </span>
        </div>
        <div class="is-flex is-align-items-center description mt-2 mb-4">
          <ArrowBack
            v-if="state.currentAnimalIndex > 0"
            class="is-clickable mr-2"
            @click="setDescription('previous')"
          />
          <textarea
            class="is-borderless"
            placeholder="Descreva o animal"
            name="description"
            is-synchronized
            :required="true"
            v-model="
              state.descriptionsToPublish[state.currentAnimalIndex]
                .publishable_description
            "
          />
          <ArrowForward
            v-if="state.currentAnimalIndex < props.animals.length - 1"
            class="is-clickable ml-2"
            @click="setDescription('next')"
          />
        </div>
        <div v-if="state.isError" class="has-text-danger mb-2">
          <span>
            {{ state.errorMessage }}
          </span>
        </div>
        <div
          class="buttons is-flex is-justify-content-space-evenly is-fullwidth"
        >
          <button class="button cancel is-outlined" @click="closeModal">
            Cancelar
          </button>
          <button
            class="button is-warning"
            @click="publishDescriptions(props.batchId)"
          >
            <span v-if="!state.isLoadingPublish">Publicar</span>
            <span v-else :class="{ loader: state.isLoadingPublish }" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowBack from "icons/cached/arrow_back.svg";
import ArrowForward from "icons/cached/arrow_forward.svg";
import { onMounted, onUnmounted } from "vue";
import {
  closeModal,
  loadDescriptions,
  publishDescriptions,
  state,
} from "./describeAnimalContext";

export default {
  components: {
    ArrowBack,
    ArrowForward,
  },
  props: {
    batchId: Number,
    animals: Array,
  },
  setup(props) {
    onMounted(() => {
      loadDescriptions(props.batchId);
    });

    onUnmounted(() => {
      state.isError = false;
      state.errorMessage = "";
    });

    const setDescription = (position) => {
      const index = position === "previous" ? -1 : 1;
      const nextIndex = state.currentAnimalIndex + index;

      state.currentAnimalIndex = nextIndex;
    };

    return {
      closeModal,
      publishDescriptions,
      setDescription,
      state,
      props,
    };
  },
};
</script>
